import React from "react";
import { Link } from "react-router-dom";

const Aboutus = () => {
  return (
    <div className="w-full px-6 md:px-16">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-10 md:gap-16">
          {/* Image */}
          <div className="w-full md:w-1/2">
            <div
              className="w-full rounded-[24px] overflow-hidden"
              style={{
                background: "linear-gradient(135deg, #D8E8FF 0%, #B0CCFF 100%)",
                padding: "8px",
              }}
            >
              <img
                src={process.env.PUBLIC_URL + "/images/ourstoryhero/mission&vision.webp"}
                alt="Built for caregivers by a caregiver"
                className="w-full h-[320px] md:h-[420px] object-cover rounded-[18px]"
                onError={(e) => {
                  e.target.src =
                    process.env.PUBLIC_URL + "/images/herosection/herobg.webp";
                }}
              />
            </div>
          </div>

          {/* Content */}
          <div className="w-full md:w-1/2 flex flex-col items-start gap-6">
            <p className="text-[13px] md:text-[14px] font-[600] text-[#1167D0] tracking-widest uppercase">
              About Us
            </p>
            <h2 className="text-[28px] md:text-[36px] font-[800] text-[#0D121F] font-avenir leading-tight">
              Built for Caregivers, by a Caregiver
            </h2>
            <p className="text-[15px] md:text-[16px] text-[#6B7280] leading-relaxed">
              Born from lived experience, Social Spectrum is a community-driven
              platform designed to empower families navigating neurodivergence.
              We understand the journey because we've lived it.
            </p>
            <p className="text-[15px] md:text-[16px] text-[#6B7280] leading-relaxed">
              Our platform brings together expert resources, compassionate
              community support, and innovative tools to help every family feel
              seen, supported, and celebrated.
            </p>
            <Link
              to="/ourstory"
              className="flex items-center gap-2 py-[12px] px-[24px] bg-[#1167D0] text-white text-[15px] font-[600] rounded-[32px] hover:bg-[#0D55B5] transition-colors"
            >
              Read Our Story →
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Aboutus;
